export const authLinkButtonSx = {
  minWidth: { xs: '65px', sm: '120px' },
  fontSize: { xs: 12, sm: '0.875rem' },
  height: '36px',
  fontWeight: 'bold',
  paddingLeft: '6px',
  paddingRight: '6px'
};
